import React from 'react';
import './ChatHistory.css';

function ChatHistory({ conversations, isLoading, error, onSelectConversation, onNewChat, onDeleteConversation, activeConversationId, isSwitching, isVisible, onClose }) {
    const handleDelete = (e, conversationId) => {
        e.stopPropagation(); // Prevent triggering conversation selection
        onDeleteConversation(conversationId);
    };

    return (
        <div className={`chat-history-sidebar ${isSwitching ? 'chat-history-sidebar--loading' : ''} ${!isVisible ? 'chat-history-sidebar--hidden' : ''}`}>
            <div className="chat-history-header">
                <div className="chat-history-header-content">
                    <h2>💬 Chat History</h2>
                    <button 
                        className="close-sidebar-button" 
                        onClick={onClose}
                        title="Close sidebar"
                    >
                        <svg viewBox="0 0 24 24" width="18" height="18">
                            <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </button>
                </div>
                <button className="new-chat-button" onClick={onNewChat}>
                    + New Chat
                </button>
            </div>
            <div className="chat-history-list">
                {isLoading && <p>Loading history...</p>}
                {error && <p className="error-message">{error}</p>}
                {!isLoading && !error && conversations.length === 0 && (
                    <p>No past conversations found.</p>
                )}
                {conversations.map((convo) => (
                    <div
                        key={convo.id}
                        className={`history-item ${convo.id === activeConversationId ? 'active' : ''}`}
                        onClick={() => onSelectConversation(convo.id)}
                    >
                        <div className="history-item-content">
                            <p className="history-title">{convo.title}</p>
                            <span className="history-timestamp">
                                {new Date(convo.last_message_at).toLocaleString()}
                            </span>
                        </div>
                        <button
                            className="delete-conversation-btn"
                            onClick={(e) => handleDelete(e, convo.id)}
                            title="Delete conversation"
                        >
                            <svg viewBox="0 0 24 24" width="16" height="16">
                                <path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                            </svg>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ChatHistory;
